/** un élément de configuration des charts */
export class ChartparameterObj {
  public code: string = '';
  public label: string = ''; // chaine non traduite
  public kind: string = ''; // FIELD_KIND
  public sourceCollection: any[] = null; // objets pour choix multiple
  public sourceField: string = null; // en cas de collection, champ à mapper. Laisser null pour l'objet complet
  public mandatory: boolean = false;
  public defaultValue: any = null; // état par défaut du compo
  public minValue: number = 0;
  public maxValue: number = null;
  public dependency: string = null; // champ maître

  public value: any = null; // la valeur en cours

  /**
   * construction
   * @param code du champ
   * @param kind type de donnée
   * @param defaultValue valeur si vide
   * @param dependency champ maître pour affichage
   * @param sourceCollection données en cas de dropDown
   * @param minValue valeur plancher
   * @param maxValue valeur max
   */
  constructor(
    code: string,
    kind: string,
    defaultValue?: any,
    dependency?: string,
    sourceCollection?: any[],
    sourceField?: string,
    minValue?: number,
    maxValue?: number
  ) {
    this.code = code;
    this.label = '$.widget.chart.param.' + code + '.$';
    this.kind = kind;
    this.defaultValue = defaultValue;
    this.value = defaultValue;
    this.dependency = dependency;
    this.sourceCollection = sourceCollection;
    this.sourceField = sourceField;
    this.minValue = minValue ? minValue : 0;
    this.maxValue = maxValue;
  }
}
